import { BFFAgent } from 'BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_FAILURE
} from '../constants'

export function getCarLotOptions() {
  return async (dispatch, getState) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_BEGIN
    })

    try {
      const result = await BFFAgent.Stock.TakingCarManagement.getCarLots()
      let data = {}
      const state = getState()
      const carLotDefault = state?.common?.user?.license?.company?.Car_lots.find(
        carlot => carlot.default
      )

      const carLotOptions = result.map(carlot => ({
        value: carlot.car_lot_id,
        label: carlot.car_lot_name
      }))

      if (carLotOptions.find(carLot => carLot.value === carLotDefault?.id)) {
        data = {
          carLotOptions,
          carLotDefault: { value: carLotDefault.id, label: carLotDefault.name }
        }
      } else {
        data = {
          carLotOptions,
          carLotDefault: carLotOptions[0]
        }
      }

      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_SUCCESS,
        data
      })
    } catch (err) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_FAILURE,
        data: err?.message
      })
    }
  }
}
